<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<canvas #chartEl></canvas>
